import React from 'react'
import { Button, Icon } from 'semantic-ui-react'
import Divider from '@ui/Divider'
import Section from '@ui/Section'
import mailbox from '@images/Survey/mailbox.svg'
import CirclesBackground from '@ui/CirclesBackground'
import './styles.scss'

const LastStep = ({
  editButton,
  submitButton,
  onEdit,
  onSubmit,
  submitting,
  title,
  description
}) => {
  return (
    <div className='last-step-container'>
      <CirclesBackground>
        <img src={mailbox} alt='mailbox' className='mailbox' />
      </CirclesBackground>
      <div className='custom-container flex vertical survey-confirmation'>
        <Section size='h1' title={title} description={description} />
        <Divider hidden />
        <div className='custom-actions button-actions flex no-wrap vertical'>
          <Button
            onClick={onSubmit}
            className='survey-button lg primary survey-confirmation-submit'
            disabled={submitting}
            loading={submitting}
          >
            {!submitting && <Icon name='paper plane' inverted />}
            {submitButton}
          </Button>
          <Button
            onClick={onEdit}
            className='survey-button basic sm survey-confirmation-edit'
          >
            <Button.Content visible>{editButton}</Button.Content>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LastStep
